import ReassignFullNameCell from './ReassignFullNameCell';

export default ReassignFullNameCell;
